import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { collection, query, where, orderBy, limit, onSnapshot, type DocumentData } from "firebase/firestore";
import { db, call } from "../firebase";
import { useSession } from "../session";
import { friendly, toast } from "../errors";

type Row = DocumentData & { id: string };

/** Số thông báo chưa đọc (hiện trên menu). */
export function useUnread(email?: string) {
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!email) return;
    return onSnapshot(query(collection(db, "notifications"), where("email", "==", email), where("read", "==", false), limit(99)),
      (s) => setN(s.size), () => setN(0));
  }, [email]);
  return n;
}

export default function Notifications() {
  const { member } = useSession();
  const nav = useNavigate();
  const [rows, setRows] = useState<Row[]>([]);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    if (!member) return;
    return onSnapshot(query(collection(db, "notifications"), where("email", "==", member.email), orderBy("createdAt", "desc"), limit(100)),
      (s) => setRows(s.docs.map((d) => ({ id: d.id, ...d.data() }))), (e) => setErr(friendly(e)));
  }, [member?.email]);

  if (!member) return null;
  const unread = rows.filter((r) => !r.read);

  const readAll = async () => {
    try { await call("markNotificationsRead")({}); } catch (e) { toast(friendly(e)); }
  };
  const open = async (r: Row) => {
    if (!r.read) void call("markNotificationsRead")({ ids: [r.id] }).catch(() => undefined);
    if (r.kind === "expiry") nav("/compliance");
    else if (r.kind === "returned") nav("/documents");
    else if (r.docId) nav(`/xem/${r.docId}`);
  };

  return (
    <>
      <div className="row" style={{ justifyContent: "space-between" }}>
        <div><h1>Thông báo</h1><p className="sub">{unread.length ? `${unread.length} thông báo chưa đọc` : "Không có thông báo mới."}</p></div>
        {unread.length > 0 && <button className="btn" onClick={readAll}>Đánh dấu đã đọc hết</button>}
      </div>
      {err && <div className="err">{err}</div>}
      <div className="card" style={{ padding: 0 }}>
        {rows.map((r) => (
          <button key={r.id} className={`notif${r.read ? "" : " unread"}`} onClick={() => open(r)}>
            <span className={`ndot ${r.kind === "returned" ? "red" : r.kind === "approved" ? "" : r.daysLeft <= 7 ? "red" : r.daysLeft <= 30 ? "gold" : ""}`} aria-hidden="true" />
            <span style={{ flex: 1, textAlign: "left" }}>{r.message}
              <span className="muted" style={{ display: "block" }}>{r.createdAt?.toDate?.().toLocaleString("vi-VN") ?? ""}{r.renewal === "in_progress" ? " · đang gia hạn" : ""}</span></span>
          </button>
        ))}
        {!rows.length && <p className="muted" style={{ padding: 16, margin: 0 }}>Chưa có thông báo nào.</p>}
      </div>
    </>
  );
}
